import styled from '@xstyled/styled-components'
import { space } from '@xstyled/system'

const Label = styled.label`
  ${space}
  margin: 2;
`

export default Label
